import React from "react";

import { formatString } from "@perceptron/utils/string";

import { strings } from "@demo/utils/strings";

import { ShimmerText } from "./ShimmerText";

export interface ToolCallResultsBodyProps {
  /** The query, shown in full above the results. */
  query?: string;
  /** The line above the results: a count once done, or a progress note while running. */
  status: string;
  statusTestId?: string;
  /** Shimmers the query while the call is still running. */
  isStreaming?: boolean;
  children: React.ReactNode;
}

/** "1 result" / "N results". */
export const describeResultCount = (count: number): string =>
  count === 1 ? strings.toolCall.resultSingular : formatString(strings.toolCall.results, count);

/**
 * The expanded body shared by every search-family card: the quoted query, a status line in the
 * disabled colour, and the tool-specific results underneath.
 */
function ToolCallResultsBody({ query, status, statusTestId, isStreaming = false, children }: ToolCallResultsBodyProps) {
  return (
    <div className="flex w-full flex-col gap-5 px-2 pb-2 pt-1">
      {query && (
        <ShimmerText as="p" className="w-full label-2" data-testid="tool-call-query" isStreaming={isStreaming}>
          “{query}”
        </ShimmerText>
      )}
      <div className="flex w-full flex-col gap-2">
        <span className="whitespace-nowrap text-foreground-disabled label-2" data-testid={statusTestId}>
          {status}
        </span>
        {children}
      </div>
    </div>
  );
}

export default ToolCallResultsBody;
